<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'

export default {
  page: {
    title: '數據分析',
    meta: [
      { name: 'description', container: 'Data Analytics' },
      // {
      //   name: 'google-signin-client_id',
      //   content:
      //     '290512385831-dmghl5rmcej3pvvap0lrt261tk1ijdrv.apps.googleusercontent.com',
      // },
      {
        name: 'google-signin-scope',
        content: 'https://www.googleapis.com/auth/analytics.readonly',
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      activeTab: '0',
      formattedJson: '',
      tabList: Object.freeze([
        {
          title: '客戶分析',
          component: () => lazyLoadComponent(import('./TabCustomer')),
        },
        {
          title: '項目分析',
          component: () => lazyLoadComponent(import('./TabProduct')),
        },
        {
          title: '訂單分析',
          component: () => lazyLoadComponent(import('./TabOrder')),
        },
      ]),
    }
  },
  created() {
    // this.accessGoogleAccount()
    // this.testAPIs()
  },
  mounted() {
    // this.importGapi()
    // this.accessGoogleAccount()
  },
  methods: {
    async accessGoogleAccount() {
      await this.$store.dispatch('analytics/initGA')
    },
    async testAPIs() {
      const dateRange = {
        startDate: '2020-01-01',
        endDate: '2020-03-31',
      }
      await this.$store.dispatch('analytics/fetchReportByCustomer', dateRange)
      await this.$store.dispatch('analytics/fetchReportByProducts', dateRange)
      await this.$store.dispatch(
        'analytics/fetchReportByProductCategory',
        dateRange
      )
      await this.$store.dispatch('analytics/fetchReportBySingleProduct', {
        productId: '46c63acf-3329-432f-b790-c3c2db42a7ee',
        ...dateRange,
      })
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageHeader>
      <template v-slot:title>數據分析</template>
      <textarea v-model="formattedJson" cols="80" rows="20"></textarea>
      <template v-slot:right>
        <el-tabs v-model="activeTab" class="is-no-border">
          <el-tab-pane
            v-for="(tab, index) in tabList"
            :key="index"
            :label="tab.title"
            :name="`${index}`"
          ></el-tab-pane>
        </el-tabs>
      </template>
    </BasePageHeader>
    <component :is="tabList[activeTab].component"></component>
  </Layout>
</template>
